import { j as x, c as T } from "../../utils-BdNIfrGQ.js";
import { D as b } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { useRef as E, useState as z, useCallback as B, useEffect as H, useMemo as A } from "react";
const D = (h = {}, i) => {
  const { top: r = !0, bottom: n = !0, left: a = !0, right: d = !0 } = h, c = E(null), [t, g] = z({
    showLeftShadow: !1,
    showRightShadow: !1,
    showTopShadow: !1,
    showBottomShadow: !1
  }), e = B(() => {
    const o = c.current;
    if (!o) return;
    const { scrollLeft: l, scrollWidth: s, clientWidth: w, scrollTop: p, scrollHeight: u, clientHeight: S } = o, f = s > w, R = f && l > 0, y = f && l < s - w - 1, m = u > S, L = m && p > 0, j = m && p < u - S - 1;
    g({
      showLeftShadow: R,
      showRightShadow: y,
      showTopShadow: L,
      showBottomShadow: j
    });
  }, []);
  H(() => {
    const o = c.current;
    if (!o) return;
    const l = requestAnimationFrame(() => {
      e();
    });
    o.addEventListener("scroll", e, { passive: !0 });
    const s = new ResizeObserver(() => {
      e();
    });
    return s.observe(o), () => {
      cancelAnimationFrame(l), o.removeEventListener("scroll", e), s.disconnect();
    };
  }, [e, i]);
  const v = A(() => {
    const o = [];
    return a && t.showLeftShadow && o.push("inset 12px 0 12px -8px hsla(0, 0%, 10%, 0.15)"), d && t.showRightShadow && o.push("inset -12px 0 12px -8px hsla(0, 0%, 10%, 0.15)"), r && t.showTopShadow && o.push("inset 0 12px 12px -8px hsla(0, 0%, 10%, 0.15)"), n && t.showBottomShadow && o.push("inset 0 -12px 12px -8px hsla(0, 0%, 10%, 0.15)"), {
      boxShadow: o.length > 0 ? o.join(", ") : "none"
    };
  }, [t, a, d, r, n]);
  return { containerRef: c, shadowState: t, shadowStyle: v };
}, C = ({
  scrollShadowConfig: h,
  recalculateDependency: i,
  children: r
}) => {
  const { containerRef: n, shadowStyle: a } = D(
    h,
    i
  );
  return /* @__PURE__ */ x.jsxs(b, { className: T("border border-gray-400 rounded-lg relative mx-[-16px] lg:mx-0"), children: [
    r(n),
    /* @__PURE__ */ x.jsx(
      b,
      {
        className: "pointer-events-none absolute inset-0 rounded-lg",
        style: a,
        "data-testid": "scroll-shadow-overlay"
      }
    )
  ] });
};
export {
  C as default
};
